import { Grid, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'

export default function Bloque1({ text1, handleDatosTextField, text8, handleDatosTextField8 }) {


    useEffect(() => {
        console.log(text1)
    }, [text1])
    
    useEffect(() => {
        console.log(text8)
    }, [text8])

    const [mostrar, setMostrar] = useState(false)

    const handleMostar = () => {
        setMostrar(!mostrar)
    }

    return (
        <Box style={{ marginTop: "20px", marginBottom: "20px" }}>
            <Typography style={{ marginBottom: "20px" }} variant="h4" >Antencedentes</Typography>

            {
                text1.filter(y => y.id === 'anteExamenFisico')
                    .map((x, ix) => (
                        <Grid key={ix} container>
                            <Grid lg={12}>
                                <Box>
                                    <TextField
                                        label={x.label}
                                        fullWidth
                                        multiline
                                        rows={7}
                                        name='anteExamenFisico'
                                        value={x.anteExamenFisico}
                                        onChange={(e) => handleDatosTextField(x.id, e.target.value, 'anteExamenFisico')}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    )
                    )
            }

            <Typography style={{ marginBottom: "10px", marginTop: "20px" }} variant="h4">Exámenes Oculares:</Typography>
            <Box style={{ display: "flex", justifyContent: "right", justifyItems: "right", alignContent: "right", alignItems: "right", marginTop: "-35px" }}>
                <Button variant='outlined' onClick={handleMostar}>{!mostrar ? "Mostrar Valores" : "Ocultar Valores"}</Button>
            </Box>

            {
                mostrar &&
                <>

                    <TableContainer style={{ marginTop: "20px", marginBottom: "20px" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontSize: "16px", textAlign: "left" }} align="left"><b>Agudeza Visual</b></TableCell>
                                    <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Derecho</b></TableCell>
                                    <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Izquierdo</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    text1.filter(y => y.id !== 'anteExamenFisico').map((x, ix) =>

                                        <TableRow key={ix + 1} hover>
                                            <>
                                                <TableCell style={{ display: x.id === 'avcsc' || x.id === 'presion' || x.id === 'paquimetria' || x.id === 'avph' || x.id === 'pupilas' || x.id === 'colores' ? 'none' : null }} align="left">
                                                    <Typography>
                                                        {x.label}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell style={{ display: x.id === 'avcsc' || x.id === 'presion' || x.id === 'paquimetria' || x.id === 'avph' || x.id === 'pupilas' || x.id === 'colores' ? 'none' : null }} align="center">
                                                    <TextField

                                                        name={x.derecho}
                                                        onChange={(e) => handleDatosTextField(x.id, e.target.value, 'derecho')}
                                                        value={x.derecho}
                                                    />
                                                </TableCell>
                                                <TableCell style={{ display: x.id === 'avcsc' || x.id === 'presion' || x.id === 'paquimetria' || x.id === 'avph' || x.id === 'pupilas' || x.id === 'colores' ? 'none' : null }} align="center">
                                                    <TextField

                                                        name={x.izquierdo}
                                                        onChange={(e) => handleDatosTextField(x.id, e.target.value, 'izquierdo')}
                                                        value={x.izquierdo}
                                                    />
                                                </TableCell>
                                            </>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TableContainer style={{ marginTop: "20px", marginBottom: "20px" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontSize: "16px", textAlign: "left" }} align="left"><b>Biomicroscopía</b></TableCell>
                                    <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Derecho</b></TableCell>
                                    <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Izquierdo</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    text8.map((x, ix) =>

                                        <TableRow key={ix + 1} hover>
                                            <>
                                                <TableCell align="left">
                                                    <Typography>
                                                        {x.titulo}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextField
                                                        multiline
                                                        rows={2}
                                                        name={x.derecho}
                                                        onChange={(e) => handleDatosTextField8(x.id, e.target.value, 'derecho')}
                                                        value={x.derecho}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextField
                                                        multiline
                                                        rows={2}
                                                        name={x.izquierdo}
                                                        onChange={(e) => handleDatosTextField8(x.id, e.target.value, 'izquierdo')}
                                                        value={x.izquierdo}
                                                    />
                                                </TableCell>
                                            </>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>

                    </TableContainer>


                    <TableContainer style={{ marginTop: "20px", marginBottom: "20px" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontSize: "16px", textAlign: "left" }} align="left"><Typography variant="h4">Tonometría:</Typography></TableCell>
                                    <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Derecho</b></TableCell>
                                    <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Izquierdo</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    text1.filter(y => y.id !== 'anteExamenFisico').map((x, ix) =>

                                        <TableRow key={ix + 1} hover>
                                            <>
                                                <TableCell style={{ display: x.id === 'avsc' || x.id === 'avcc' || x.id === 'paquimetria' || x.id === 'avph' || x.id === 'avph' || x.id === 'avcsc' || x.id === 'pupilas' || x.id === 'colores' ? 'none' : null }} align="left">
                                                    <Typography>
                                                        {x.label}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell style={{ display: x.id === 'avsc' || x.id === 'avcc' || x.id === 'paquimetria' || x.id === 'avph' || x.id === 'avph' || x.id === 'avcsc' || x.id === 'pupilas' || x.id === 'colores' ? 'none' : null }} align="center">
                                                    <TextField

                                                        name={x.derecho}
                                                        onChange={(e) => handleDatosTextField(x.id, e.target.value, 'derecho')}
                                                        value={x.derecho}
                                                    />
                                                </TableCell>
                                                <TableCell style={{ display: x.id === 'avsc' || x.id === 'avcc' || x.id === 'paquimetria' || x.id === 'avph' || x.id === 'avph' || x.id === 'avcsc' || x.id === 'pupilas' || x.id === 'colores' ? 'none' : null }} align="center">
                                                    <TextField

                                                        name={x.izquierdo}
                                                        onChange={(e) => handleDatosTextField(x.id, e.target.value, 'izquierdo')}
                                                        value={x.izquierdo}
                                                    />
                                                </TableCell>
                                            </>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>

                    </TableContainer>
                    <TableContainer style={{ marginTop: "20px", marginBottom: "20px" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontSize: "16px", textAlign: "left" }} align="left"><Typography variant="h4">Paquimetría:</Typography></TableCell>
                                    <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Derecho</b></TableCell>
                                    <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Izquierdo</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    text1.filter(y => y.id !== 'anteExamenFisico').map((x, ix) =>

                                        <TableRow key={ix + 1} hover>
                                            <>
                                                <TableCell style={{ display: x.id === 'avsc' || x.id === 'avcc' || x.id === 'presion' || x.id === 'avph' || x.id === 'avph' || x.id === 'avcsc' || x.id === 'pupilas' || x.id === 'colores' ? 'none' : null }} align="left">
                                                    <Typography>
                                                        {x.label}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell style={{ display: x.id === 'avsc' || x.id === 'avcc' || x.id === 'presion' || x.id === 'avph' || x.id === 'avph' || x.id === 'avcsc' || x.id === 'pupilas' || x.id === 'colores' ? 'none' : null }} align="center">
                                                    <TextField

                                                        name={x.derecho}
                                                        onChange={(e) => handleDatosTextField(x.id, e.target.value, 'derecho')}
                                                        value={x.derecho}
                                                    />
                                                </TableCell>
                                                <TableCell style={{ display: x.id === 'avsc' || x.id === 'avcc' || x.id === 'presion' || x.id === 'avph' || x.id === 'avph' || x.id === 'avcsc' || x.id === 'pupilas' || x.id === 'colores' ? 'none' : null }} align="center">
                                                    <TextField

                                                        name={x.izquierdo}
                                                        onChange={(e) => handleDatosTextField(x.id, e.target.value, 'izquierdo')}
                                                        value={x.izquierdo}
                                                    />
                                                </TableCell>
                                            </>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>

                    </TableContainer>
                </>
            }



        </Box>
    )
}
